// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"edd9051f","453":"10876605"}[chunkId] + ".chunk.js";
};